import React from 'react'
import styled from 'styled-components'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import DialogContentText from '@material-ui/core/DialogContentText'
import Moment from 'moment-timezone'

const styles = theme => ({
  dialogContent: {
    width: 248,
    paddingBottom: 0,
    paddingTop: '0 !important',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    width: 'fit-content',
  },
  selectField: {
    width: 200,
  },
  textField: {
    width: 200,
  },
})

const formDefaults = {
  valid: true,
  valueType: null,
  decimalPlaces: 0,
  manualInputId: "",
  date: "",
  value: "",
  comment: "",
  manualInputIdError: false,
  dateError: false,
  valueError: false,
  commentError: false,
}

class AddManualInputForm extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      ...formDefaults
    }
  }

  componentDidUpdate(lastProps) {
    if (lastProps.timezone!==this.props.timezone) {
      this.setState({
        date: Moment.tz(new Date(),this.props.timezone).format('YYYY-MM-DD'),
      })
    }
  }

  handleInputChange = event => {
    const value = event.target.value
    const selectedManualInput = (event.target.name==="manualInputId") ? this.props.manualInputs.find((o) => o.id===value) : null
    const errorState = {}
    if (value) errorState[`${[event.target.name]}Error`] = false
    this.setState({
      [event.target.name]: value,
      valueType: selectedManualInput ? selectedManualInput.manual_input_type_value_type : this.state.valueType,
      decimalPlaces: selectedManualInput ? selectedManualInput.decimal_places : this.state.decimalPlaces,
      ...errorState
    })
  }

  validate = () => {
    let valid = true
    const errorState = {
      manualInputIdError: false,
      dateError: false,
      valueError: false,
      commentError: false,
    }
    const { manualInputId, date, value, comment, valueType } = this.state
    if (!manualInputId) {
      valid = false
      errorState['manualInputIdError'] = true
    }
    if (!date) {
      valid = false
      errorState['dateError'] = true
    }
    if (valueType==="numeric" && !value) {
      valid = false
      errorState['valueError'] = true
    }
    if (valueType==="text" && !comment) {
      valid = false
      errorState['commentError'] = true
    }
    errorState['valid'] = valid
    this.setState(errorState)
    return valid
  }

  handleSubmit = () => {
    if (!this.validate()) return true
    const { manualInputId, date, value, comment, valueType } = this.state
    this.props.submitHandler.call(this,{
      manual_input_id: manualInputId,
      date,
      value_type: valueType,
      value: value,
      comment,
    })
  }

  renderBody = (props,state) => <Dialog
    disableBackdropClick
    disableEscapeKeyDown
    open={props.open}
  >
    <DialogTitle id="form-dialog-title">Add Manual Input</DialogTitle>
    <form autoComplete="off">
      <DialogContent className={props.classes.dialogContent}>
        <FormControl fullWidth={true} className={props.classes.formControl}>
          <InputLabel htmlFor="select-manual-input">Input</InputLabel>
          <Select
            className={props.classes.selectField}
            error={this.state.manualInputIdError}
            inputProps={{
              name: 'manualInputId',
              id: 'select-manual-input',
            }}
            value={this.state.manualInputId}
            onChange={this.handleInputChange}
          >
            <MenuItem value="" key={0}>Select</MenuItem>
            {props.manualInputs && props.manualInputs.map((item,index) => <MenuItem value={item.id} key={index+1}>{item.label}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl fullWidth={true} className={props.classes.formControl}>
          <TextField
            id="textinput-date"
            name="date"
            label="Date"
            type="date"
            className={props.classes.textField}
            error={this.state.dateError}
            InputLabelProps={{
              shrink: true,
            }}
            value={this.state.date}
            onChange={this.handleInputChange}
          />
        </FormControl>
        {(state.valueType==="numeric" || !state.valueType) &&
          <FormControl fullWidth={true} className={props.classes.formControl}>
            <TextField
              className={props.classes.textField}
              error={this.state.valueError}
              id="textinput-value"
              name="value"
              type="number"
              inputProps={{
                step: 1/Math.pow(10,this.state.decimalPlaces),
              }}
              label="Value"
              value={this.state.value}
              onChange={this.handleInputChange}
            />
          </FormControl>
        }
        {(state.valueType==="text") &&
          <FormControl fullWidth={true} className={props.classes.formControl}>
            <TextField
              className={props.classes.textField}
              error={this.state.commentError}
              id="textinput-comment"
              name="comment"
              label="Comment"
              value={this.state.comment}
              onChange={this.handleInputChange}
            />
          </FormControl>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={this.props.closeHandler} color="primary">
          Cancel
        </Button>
        <Button onClick={this.handleSubmit} color="primary">
          Submit
        </Button>
      </DialogActions>
    </form>
  </Dialog>

  render = () => {
    return this.renderBody(this.props,this.state)
  }

}

export default withStyles(styles)(AddManualInputForm)



// WEBPACK FOOTER //
// ./src/components/dataViews/AddManualInputForm.js